module.exports = __webpack_public_path__ + "static/img/service-info-safe.58df48b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/service-info-safe.png
// module id = J5qK
// module chunks = 0